var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.transitions),function(transition){return _c('v-btn',{key:transition.id,staticClass:"mx-2",attrs:{"data":transition,"disabled":_vm.isDisabled(transition.requiresValidContent),"light":""},on:{"click":function($event){return _vm.save(transition.to)}}},[_vm._v(" "+_vm._s(transition.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }